import React, { useEffect, useState } from "react";
import {
    IonPage,
    IonContent,
    IonCard,
    IonCardContent,
    IonButton,
    IonLabel,
    IonItem,
    IonRadioGroup,
    IonRadio,
    IonAlert,
} from "@ionic/react";

interface QuestionData {
    question: string;
    options: string[];
    correctAnswer: string;
}


const SimpleFutureTenseWorksheet: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [questions, setQuestions] = useState<QuestionData[]>([]);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    const handleSubmit = (option: React.SetStateAction<string | null>) => {
        setSelectedOption(option);
        const currentQuestion = questions[currentIndex];
        if (option === currentQuestion.correctAnswer) {
            // Automatically move to the next question
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                    setShowImage(false);
                    setSelectedOption(null);
                }
                else {
                    setCurrentIndex(0);
                    fetchQuestions();
                }
            }, 5000); // Delay reduced to 3 seconds
        }
    };

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'SimpleFutureTense.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/SimpleFutureTense.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class One - English - Simple Tenses - Simple Future Tense"; // Set page title
    }, []);


    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter fillPreposition additionWord" style={{ padding: "0%" }}>
                        <p>
                            <strong>Instructions:</strong> Choose the correct simple present
                            tense sentence from the options below.
                        </p>

                        <div className="mb-4">
                            {questions[currentIndex]?.question}
                        </div>
                        <div className="mb-5">
                            <IonRadioGroup
                                value={selectedOption}
                                onIonChange={(e) => handleSubmit(e.detail.value!)}
                            >
                                {questions[currentIndex]?.options.map(
                                    (option, index) => (
                                        <IonItem
                                            className={` ${selectedOption === option
                                                    ? option === questions[currentIndex]?.correctAnswer
                                                        ? "correct"
                                                        : "errorItems"
                                                    : ""
                                                }`}
                                            key={index}>
                                            <IonLabel>{option}</IonLabel>
                                            <IonRadio slot="start" value={option} />
                                        </IonItem>
                                    )
                                )}
                            </IonRadioGroup>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: "150px" }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default SimpleFutureTenseWorksheet;
